module.exports = __webpack_public_path__ + "static/media/share.e8680fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/share.jpg
// module id = 718
// module chunks = 0